import React, { useEffect, useState } from "react";
import "../styles/AdminContact.css";
import axiosClient from "../api/axiosClient";

const AdminContact = ({}) => {

  const toggleRead = async(id) => {
      
          try {
      
            const token = localStorage.getItem("admintoken");
      
            const res = await axiosClient.put(
              `/auth/admin/contacts/${id}/read`,
              {},
              {
                headers: {
                  Authorization: `${token}`,
                },
              }
            );
             fetchContact();
            console.log(res.data);
      
            // setContact(res.data.content);
      
          } catch (error) {
            console.log(error);
        };
  
  };

    const fetchContact = async () => {
      
          try {
      
            const token = localStorage.getItem("admintoken");
      
            const res = await axiosClient.get(
              "/auth/admin/contactsDetails",
              {
                params: {
                  page,
                  size,
                },
                headers: {
                  Authorization: `${token}`,
                },
              }
            );
      
            setContact(res.data.content);
      
          } catch (error) {
            console.log(error);
          }
        };

         const [contact, setContact] = useState([]);
              const [page, setPage] = useState(0);
            
              const size = 10;
      
              useEffect(() => {
                fetchContact();
              }, [page]);

  return (
    <div className="adminContact">

      <div className="contact-heading">
        Contact Messages
      </div>

      <p className="contact-para">
        View messages sent from the contact form
      </p>

      <div className="contact-table-wrapper">

        <table className="contact-table">

          <thead>
            <tr>
              {/* <th>#</th> */}
              <th>Name</th>
              <th>Surname</th>
              <th>Email</th>
              <th>PhoneNumber</th>
              <th>Message</th>
              <th>Created Date</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>

            {contact.map((item, index) => (
              <tr key={index}>

                {/* <td>{(page - 1) * size + index + 1}</td> */}
                <td>{item.name}</td>
                <td>{item.surname}</td>
                <td>{item.email}</td>
                <td>{item.phoneNumber}</td>
                <td>{item.message}</td>
                <td>{item.createdAt}</td>
   <td>
       <button
  className={item.read ? "contact-read-btn" : "contact-unread-btn"}
  onClick={() => toggleRead(item.id)}
>
  {item.read ? "Unread" : "Read"}
</button>
      </td>
              </tr>
            ))}

          </tbody>

        </table>

      </div>

      {/* Pagination */}

     <div className="contact-pagination-wrapper">

  <button
    className="contact-pagination-btn"
    onClick={() => setPage(page - 1)}
    disabled={page === 0}
  >
    Prev
  </button>

  <span className="contact-pagination-text">
    Page {page + 1}
  </span>

  <button
    className="contact-pagination-btn"
    onClick={() => setPage(page + 1)}
    disabled={contact.length < size}
  >
    Next
  </button>

</div>

    </div>
  );
};

export default AdminContact;